import { useLocation, useNavigate } from "react-router-dom";
import { JitsiMeeting } from "@jitsi/react-sdk";
import { useEffect, useRef } from "react";
import axios from "axios";
import Navbar from "../header";
import Footer from "../footer";

export default function VideoCallPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const apiRef = useRef(null);

  const userName =
    state?.user_name ||
    localStorage.getItem("user_name") ||
    "Guest User";

  const roomName = `${state?.app_id}/${state?.room}`;

  // 🔥 Function to send chat to backend
  const sendChatToBackend = async (messageData) => {
    try {
      alert(messageData.message);
      
      /* await axios.post("https://yourdomain.com/api/video-chat-message", {
        room: roomName,
        sender: messageData.from,
        senderName: messageData.nick,
        message: messageData.message,
        timestamp: new Date().toISOString(),
      }); */
    } catch (error) {
      console.error("Error saving chat:", error);
    }


  };

  useEffect(() => {
    if (!apiRef.current) return;

    // When meeting is closed → redirect
    apiRef.current.addEventListener("readyToClose", () => {
      navigate("/dashboard");
    });

    // Listen for incoming messages
    apiRef.current.addEventListener("incomingMessage", (event) => {
      console.log("Chat message:", event);

      sendChatToBackend({
        from: event.from,
        nick: event.nick,
        message: event.message,
      });
    });
  }, [navigate]);

  return (
    <>
      <Navbar menuColor="red" />

      <div style={{ height: "100vh", background: "#0f2027" }}>
        <JitsiMeeting
          domain="8x8.vc"
          roomName={roomName}
          userInfo={{
            displayName: userName,
          }}
          configOverwrite={{
            startWithAudioMuted: false,
            startWithVideoMuted: false,
            enableLobby: false,
            prejoinPageEnabled: false,
          }}
          interfaceConfigOverwrite={{
            DISABLE_CHAT: false,
          }}
          getIFrameRef={(iframe) => {
            iframe.style.height = "100%";
          }}
          onApiReady={(externalApi) => {
            apiRef.current = externalApi;

            // Auto open chat panel
            externalApi.executeCommand("toggleChat");
          }}
        />
      </div>

      <Footer />
    </>
  );
}
